import gql from "graphql-tag";
const DELETE_CONTEST = gql `
  mutation deleteContest($id: ID!) {
    deleteContest(id: $id) {
      status
    }
  }
`;
export default DELETE_CONTEST;
